<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-input-field
				formControlName="averageElectricConsumption"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|average-electric-consumption'
				" />
			<app-input-field
				formControlName="electricBatteryCapacity"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|electric-battery-capacity'
				" />
		</div>
		<div>
			<app-input-field
				formControlName="electricBatteryVoltage"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|electric-battery-voltage'
				" />
			<app-single-dropdown
				formControlName="electricBatteryType"
				[label]="
					'vehicles|record|motor-section|field-label|electric-battery-type'
				"
				[selectOptions]="electricBatteryType" />
		</div>
		<div>
			<app-input-field
				formControlName="electricMotorOutput"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|electric-motor-output'
				" />
			<app-input-field
				formControlName="electricMotorRangeFrom"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|electric-motor-range-from'
				" />
		</div>
		<div>
			<app-input-field
				formControlName="electricMotorRangeTo"
				[isNumber]="true"
				[label]="
					'vehicles|record|motor-section|field-label|electric-motor-range-to'
				" />
		</div>
	</form>
</app-section-wrapper-container>
